<template>
  <div class="batch-edit add-page">
    <div>
      <el-form v-if="form" :model="form" ref="form" :disabled="false" label-width="120px" :hide-required-asterisk="true">
        <div @keyup.enter.stop="save()">
          <div>考生基本信息</div>
          <el-form-item label="考生账号">
            {{form.phoneNumber||form.email||form.examineeIdNo}}
          </el-form-item>
          <el-form-item label="考生姓名" prop="examineeName">
            {{form.examineeName}}
          </el-form-item>
          <el-form-item label="姓名拼音" prop="examineeNameSpell">
            {{form.examineeNameSpell}}
          </el-form-item>
          <el-form-item label="考生性别" prop="examineeSex">
            {{$enums.sex[form.examineeSex]}}
          </el-form-item>
          <el-form-item label="出生日期" prop="birthday">
            {{form.birthday}}
          </el-form-item>
          <el-form-item label="证件类型" prop="idType">
            {{$enums.idType[form.idType]}}
          </el-form-item>
          <el-form-item label="证件号码" prop="examineeIdNo">
            {{form.examineeIdNo}}
          </el-form-item>
          <div>报考科目信息</div>
          <el-form-item label="选择教材" prop="subjectGroupId" :rules="[{required: true, message: '请选择', trigger: 'change'}]">
            <el-select v-model="form.subjectGroupId" @change="onSubjectGroupChange(JSON.parse(JSON.stringify(form)))" placeholder="选择教材" filterable style="width: 100%;">
              <el-option v-for="(item,index) in subjectGroupList" :key="index" :label="item.subjectGroupName" :value="item.subjectGroupId" :class="item.disabled?'none':''"></el-option>
            </el-select>
          </el-form-item>
          <div v-for="(subject,b) in form.subjectList" :key="'b'+b" class="border" style="margin-bottom: 20px;">
            <div style="color: #666666;margin-bottom: 20px;">{{subject.gradeSubjectName}}({{$enums.subjectType[subject.subjectType]}})</div>
            <div v-if="subject.subjectDesc" style="color: #666666;margin-bottom: 20px;">
              ({{subject.subjectDesc}})
            </div>
            <div v-if="!subject.isGroup && !subject.isQuestionRequired && Number(subject.subjectType) === 2">
              <el-checkbox checked disabled class="block">
                系统抽题
              </el-checkbox>
            </div>
            <template v-else>
              <el-form-item v-for="(questionGroup,c) in subject.questionGroupList" :key="'c'+c" label="" label-width="0px"
                            :prop="'subjectList.'+b+'.questionGroupList.'+c+'.questionIds'" class="border" style="margin-bottom: 20px;"
                            :rules="[{required: true, message: '请选择', trigger: 'change'}]">
                <div v-if="questionGroup.questionGroupName" style="color: #666666;">
                  {{questionGroup.questionGroupName}}{{questionGroup.questionGroupDesc?`(${questionGroup.questionGroupDesc})`:''}}
                </div>
                <el-checkbox-group v-model="questionGroup.questionIds">
                  <el-checkbox v-for="(question,d) in questionGroup.questionList" :key="'d'+d" :label="question.questionId"
                               :disabled="!!question.isRequired || !!question.disabled" class="block" @change="onCheckboxChange(questionGroup)">
                    <span v-if="question.isRequired" style="color: red;vertical-align: text-top;">*</span> <span class="questionContent">{{question.questionContent}}</span>
                  </el-checkbox>
                </el-checkbox-group>
              </el-form-item>
            </template>
          </div>
        </div>
      </el-form>
    </div>
    <div class="text-right add-bottom fixed">
      <el-button size="medium" @click="$router.push({path:'./order',query:$route.query})">返回</el-button>
      <el-button size="medium" type="primary" @click="save()" style="margin-right: 10px;">保存</el-button>
      <el-button v-if="form && form.status<=1 && form.nextId && !form.chooseQuestionStep" size="medium" type="primary" @click="next()" style="margin-right: 10px;">保存并下一个</el-button>
    </div>
  </div>
</template>
<script>
export default {
  name: 'edit',
  components: {},
  props: [],
  data () {
    return {
      form: null,
      subjectGroupList: []
    }
  },
  async created () {
    await this.initForm()
  },
  async mounted () {
  },
  async beforeDestroy () {
  },
  computed: {},
  watch: {},
  methods: {
    async initForm () {
      if (this.$route.query.examId) {
        let info = await this.$HTTP.ApiExamOnline.getExamInfo(this.$route.query.examId)
        info.certificateUrl2 = await this.$HTTP.ApiOss.signatureUrl(info.certificateUrl, 'exam-data')
        // 考生科目列表
        let subjectList = await this.$HTTP.ApiExamOnline.getExamSubjectList(this.$route.query.examId) || []
        // 科目分组列表
        this.subjectGroupList = await this.$HTTP.ApiExamOnline.getSubjectGroupList(info.gradeId) || []
        if (this.Tool.isNull(subjectList)) {
          info.subjectGroupId = this.subjectGroupList[0].subjectGroupId
          // 新增
          info.isAdd = true
          this.onSubjectGroupChange(info)
        } else {
          info.subjectGroupId = subjectList[0].subjectGroupId
          this.onSubjectGroupChange(info, subjectList)
        }
      } else {
        throw new Error('examId不能为空')
      }
      this.$nextTick(() => {
        if (this.$refs['form']) {
          this.$refs['form'].clearValidate()
        }
      })
    },
    onSubjectGroupChange (info, subjectList = []) {
      for (let a in this.subjectGroupList) {
        let subjectGroup = this.subjectGroupList[a]
        if (subjectGroup.subjectGroupId === info.subjectGroupId) {
          info.subjectList = JSON.parse(JSON.stringify(subjectGroup.subjectList))
          for (let b in info.subjectList) {
            let subject = info.subjectList[b]
            for (let c in subject.questionGroupList) {
              let questionGroup = subject.questionGroupList[c]
              let questionIds = []
              for (let d in questionGroup.questionList) {
                let question = questionGroup.questionList[d]
                if (question.isRequired) {
                  questionIds.push(question.questionId)
                }
                if (!this.Tool.isNull(subjectList)) {
                  for (let i in subjectList) {
                    let subject2 = subjectList[i]
                    if (subject2.gradeSubjectId === subject.gradeSubjectId) {
                      for (let j in subject2.questionList) {
                        let question2 = subject2.questionList[j]
                        if (question2.questionGroupId === questionGroup.questionGroupId && question.questionId === question2.questionId && !questionIds.includes(question2.questionId)) {
                          questionIds.push(question2.questionId)
                        }
                      }
                    }
                  }
                }
              }
              questionGroup.questionIds = questionIds
              this.onCheckboxChange(questionGroup)
            }
          }
          this.form = info
          this.$forceUpdate()
          this.$nextTick(() => {
            if (this.$refs['form']) {
              this.$refs['form'].clearValidate()
            }
          })
        }
      }
    },
    onCheckboxChange (questionGroup) {
      if (questionGroup.questionIds.length >= Number(questionGroup.chooseQuestionNum)) {
        for (let d in questionGroup.questionList) {
          let question = questionGroup.questionList[d]
          if (!questionGroup.questionIds.includes(question.questionId)) {
            question.disabled = true
          }
        }
      } else {
        for (let d in questionGroup.questionList) {
          let question = questionGroup.questionList[d]
          question.disabled = false
        }
      }
    },
    async save () {
      let isOK = await this.Tool.checkForm(this.$refs['form'])
      if (isOK) {
        let info = JSON.parse(JSON.stringify(this.form))
        for (let b in info.subjectList) {
          let subject = info.subjectList[b]
          let questionList = []
          for (let c in subject.questionGroupList) {
            let questionGroup = subject.questionGroupList[c]
            if (questionGroup.questionIds.length < Number(questionGroup.chooseQuestionNum)) {
              if (!subject.isGroup && !subject.isQuestionRequired && Number(subject.subjectType) === 2) {
                console.log('系统抽题')
                let questionIds = []
                for (let d in questionGroup.questionList) {
                  let question = questionGroup.questionList[d]
                  questionIds.push(question.questionId)
                }
                questionGroup.questionIds = questionIds
              } else {
                throw new Error(`科目${subject.gradeSubjectName}${questionGroup.questionGroupName ? ('(' + questionGroup.questionGroupName + ')') : ''}中应选择${questionGroup.chooseQuestionNum}道题`)
              }
            }
            for (let d in questionGroup.questionList) {
              let question = questionGroup.questionList[d]
              if (questionGroup.questionIds.includes(question.questionId)) {
                questionList.push(question)
              }
            }
          }
          subject.questionList = questionList
        }
        if (this.form.isAdd) {
          await this.$HTTP.ApiExamOnline.addExamSubject(info)
        } else {
          await this.$HTTP.ApiExamOnline.editExamSubject(info)
        }
        this.$message({ type: 'success', message: '保存成功' })
        await this.initForm()
      }
    },
    async next () {
      await this.save()
      let query = this.$route.query
      window.location.href = `/?#/order/order-question-edit?batchId=${query.batchId}&examId=${this.form.nextId}`
      window.location.reload()
    }
  }
}
</script>
<style>
  .questionContent {
    display: inline-block;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: normal;
    vertical-align: text-top;
  }
</style>
